/**
 * The seam for code OUTSIDE my-orders that refreshes a list: `homeLayout`'s notification poll,
 * `saleHelpers` after a sale is accepted, and `useCancellationFlow` after a void. v2's store fills
 * only from v2's own actions, so each caller asks which model is live.
 *
 * Usage keeps v1's line exactly where it was, one `if` in front of it:
 *
 *   if (!refreshOrdersList("overview", "delivery")) dispatch(getOverviewOrderData({ data: obj }));
 *
 * so a v1 terminal dispatches v1's action and a v2 terminal refreshes v2's list. When v1 is
 * deleted, the `if` and its tail go together.
 */
import store from "../redux-store";
import { ordersV2Active } from "./config";
import { listPayload, storeKeyFor, type Channel } from "./buckets";
import { ordersRequested } from "./slice";

/**
 * Refresh the list behind one tab when v2 is the live model.
 *
 * @returns `true` when v2 handled it — the caller must then NOT dispatch its v1 action; `false`
 *          when this terminal is still on v1 and the caller's own dispatch stands.
 */
export function refreshOrdersList(tab: string, channel: Channel, quiet = true): boolean {
  if (!ordersV2Active()) return false;
  const storeKey = storeKeyFor(tab);
  if (!storeKey) return false;
  store.dispatch(ordersRequested({ storeKey, ...listPayload(channel, tab, quiet) }));
  return true;
}
